<template>
  <div v-if="viewdata.type === 'materialitygllevel' || viewdata.type === 'bulkmaterialitygllevel' || viewdata.type === 'materialitysllevel' || viewdata.type === 'bulkmaterialitysllevel'">
    <div class="d-flex flex-column gap-3">
      <v-row v-if="(viewdata.data[0]?.periods || []).length" no-gutters class="align-center">
        <v-col cols="12" sm="3" class="details-label">
          Applicable {{$nova.labelsName('approvals_page','month_label','Period') }}
        </v-col>
        <v-col cols="12" sm="9" class="details-value">
          <div class="selected-months">
            <ul>
              <li v-for="(month, index) in viewdata.data[0]?.periods" :key="index" class='month-item'>
                  {{ month }}
              </li>
            </ul>
          </div>
        </v-col>
      </v-row>

      <v-row no-gutters class="align-center">
        <v-col cols="12" sm="3" class="details-label">
          Selected {{$nova.labelsName('approvals_page','ru_entity_plural_label','RUs')}}
        </v-col>
        <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
          <div 
            class=""
            v-for="(v,k) in viewdata.reportingunit_detail" 
            :key="k"
          >
            <v-chip label class="RU-Chip"><span class="noTransform RU-Chip-Text">{{v.code}} - {{v.name}}</span></v-chip>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="mt-2">
      <lb-datatablenew :headers="glheaders" :items="gldata['one'] || []"
        :enableslot="['period', 'gl_code_desc', 'datatypes', 'control_thresholds_amount', 'control_thresholds_percent', 'floor_control_thresholds_amount', 'management_thresholds_amount', 'management_thresholds_percent', 'floor_management_thresholds_amount', 'control_thresholds_amount_regional', 'control_thresholds_percent_regional', 'floor_control_thresholds_amount_regional','management_thresholds_amount_regional','management_thresholds_percent_regional','floor_management_thresholds_amount_regional']">
        <template v-slot:period="{ item }">
          <div class="text-center" v-if="item.period">
            {{ item?.period || 'All' }}</div>
          <div class="text-center" v-else>-</div>
        </template>
        <template v-slot:gl_code_desc="{ item }">
          <div class="text-left">
            <div class="font-weight-medium">{{ item.code }}</div>
            <div class="grey--text text--secondary text-caption">{{ item.name }}</div>
          </div>
        </template>
        <template v-slot:datatypes="">
          <div class='ellipsis-on text-left noTransform'>
            vs {{ proformaLabel }}
          </div>
          <div class='ellipsis-on text-left noTransform'>
            vs {{ forecastLabel }}
          </div>
        </template>
        <template v-slot:control_thresholds_amount="{ item }">
          <div class="text-right cell-input" v-if="item.control_thresholds_amount_proforma || item.control_thresholds_amount_proforma === 0">
            {{ $nova.formatNumber(item.control_thresholds_amount_proforma) || 0 }}</div>
          <div class="text-right cell-input" v-else>-</div>
          <div class="text-right cell-input" v-if="item.control_thresholds_amount_forecast || item.control_thresholds_amount_forecast === 0">
            {{ $nova.formatNumber(item.control_thresholds_amount_forecast) || 0 }}</div>
          <div class="text-right cell-input" v-else>-</div>
        </template>
        <template v-slot:control_thresholds_percent="{ item }">
          <div class="text-right cell-input" v-if="item.control_thresholds_percent_proforma || item.control_thresholds_percent_proforma === 0">
            {{ item.control_thresholds_percent_proforma || 0 }}%</div>
          <div class="text-right cell-input" v-else>-</div>
          <div class="text-right cell-input" v-if="item.control_thresholds_percent_forecast || item.control_thresholds_percent_forecast === 0">
            {{ item.control_thresholds_percent_forecast || 0 }}%</div>
          <div class="text-right cell-input" v-else>-</div>
        </template>
        <template v-slot:management_thresholds_amount="{ item }">
          <div class="text-right cell-input" v-if="item.management_thresholds_amount_proforma || item.management_thresholds_amount_proforma === 0">
            {{ $nova.formatNumber(item.management_thresholds_amount_proforma) }}</div>
          <div class="text-right cell-input" v-else>-</div>
          <div class="text-right cell-input" v-if="item.management_thresholds_amount_forecast || item.management_thresholds_amount_forecast === 0">
            {{ $nova.formatNumber(item.management_thresholds_amount_forecast) }}</div>
          <div class="text-right cell-input" v-else>-</div>
        </template>
        <template v-slot:management_thresholds_percent="{ item }">
          <div class="text-right cell-input" v-if="item.management_thresholds_percent_proforma || item.management_thresholds_percent_proforma === 0">
            {{ item.management_thresholds_percent_proforma || 0 }}%</div>
          <div class="text-right cell-input" v-else>-</div>
          <div class="text-right cell-input" v-if="item.management_thresholds_percent_forecast || item.management_thresholds_percent_forecast === 0">
            {{ item.management_thresholds_percent_forecast || 0 }}%</div>
          <div class="text-right cell-input" v-else>-</div>
        </template>
        <template v-slot:control_thresholds_amount_regional="{ item }">
          <div class="text-right cell-input" v-if="item.control_thresholds_amount_regional_proforma || item.control_thresholds_amount_regional_proforma === 0">
            {{ $nova.formatNumber(item.control_thresholds_amount_regional_proforma) || 0 }}</div>
          <div class="text-right cell-input" v-else>-</div>
          <div class="text-right cell-input" v-if="item.control_thresholds_amount_regional_forecast || item.control_thresholds_amount_regional_forecast === 0">
            {{ $nova.formatNumber(item.control_thresholds_amount_regional_forecast) || 0}}</div>
          <div class="text-right cell-input" v-else>-</div>
        </template>
        <template v-slot:control_thresholds_percent_regional="{ item }">
          <div class="text-right cell-input" v-if="item.control_thresholds_percent_regional_proforma || item.control_thresholds_percent_regional_proforma === 0">
            {{ item.control_thresholds_percent_regional_proforma }}%</div>
          <div class="text-right cell-input" v-else>-</div>
          <div class="text-right cell-input" v-if="item.control_thresholds_percent_regional_forecast || item.control_thresholds_percent_regional_forecast === 0">
            {{ item.control_thresholds_percent_regional_forecast }}%</div>
          <div class="text-right cell-input" v-else>-</div>
        </template>
        <template v-slot:management_thresholds_amount_regional="{ item }">
          <div class="text-right cell-input" v-if="item.management_thresholds_amount_regional_proforma || item.management_thresholds_amount_regional_proforma === 0">
            {{ item.management_thresholds_amount_regional_proforma }}</div>
          <div class="text-right cell-input" v-else>-</div>
          <div class="text-right cell-input" v-if="item.management_thresholds_amount_regional_forecast || item.management_thresholds_amount_regional_forecast === 0">
            {{ $nova.formatNumber(item.management_thresholds_amount_regional_forecast) }}</div>
          <div class="text-right cell-input" v-else>-</div>
        </template>
        <template v-slot:management_thresholds_percent_regional="{ item }">
          <div class="text-right cell-input" v-if="item.management_thresholds_percent_regional_proforma || item.management_thresholds_percent_regional_proforma === 0">
            {{ item.management_thresholds_percent_regional_proforma }}%</div>
          <div class="text-right cell-input" v-else>-</div>
          <div class="text-right cell-input" v-if="item.management_thresholds_percent_regional_forecast || item.management_thresholds_percent_regional_forecast === 0">
            {{ item.management_thresholds_percent_regional_forecast }}%</div>
          <div class="text-right cell-input" v-else>-</div>
        </template>
      </lb-datatablenew>
    </div>
  </div>
</template>

<script>
import { getGlHeaders } from './constants';

export default {
  name: 'ApprovalMaterialityGl',
  props: {
    viewdata: {
      type: Object,
      required: true
    },
    gldata: {
      type: Object,
      default: () => ({})
    },
    proccesed_cycle: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    glheaders() {
      return getGlHeaders(this);
    },
    /**
     * Dynamic label for Actual based on reporting_type
     * Returns balance sheet specific label when type is 'bs', otherwise default
     */
    actualLabel() {
      return this.viewdata.reporting_type === 'bs'
        ? this.$nova.labelsName('cycle_page', 'actual_label_balancesheet', 'Actual')
        : this.$nova.labelsName('cycle_page', 'actual_label', 'Actual');
    },
    /**
     * Dynamic label for Proforma based on reporting_type
     * Returns balance sheet specific label when type is 'bs', otherwise default
     */
    proformaLabel() {
      return this.viewdata.reporting_type === 'bs'
        ? this.$nova.labelsName('cycle_page', 'proforma_shortform_label_balancesheet', 'Proforma')
        : this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma');
    },
    /**
     * Dynamic label for Forecast based on reporting_type
     * Returns balance sheet specific label when type is 'bs', otherwise default
     */
    forecastLabel() {
      return this.viewdata.reporting_type === 'bs'
        ? this.$nova.labelsName('cycle_page', 'forecast_shortform_label_balancesheet', 'Forecast')
        : this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast');
    },
  }
}
</script>

<style scoped>
.selected-months {
  margin-top: 0px;
}
.selected-months ul {
  display: flex;
  flex-wrap: wrap; /* Allows items to wrap to the next line */
  padding: 0;
  margin: 0;
  list-style-type: none; /* Remove default list styling */
  gap: 8px; /* Space between items */
}
.month-item {
  display: flex;
  align-items: center;
  padding: 8px;
  background-color: #ecf4f5; /* Background color for items */
  border-radius: 4px;
  font-size: var(--font-size-xs);
  color: var(--blue-500);
  font-weight: 400;
}
.RU-Chip {
  max-width: fit-content;
  border-radius: var(--radius-sm, 8px) !important;
  border: 1px solid var(--grey-300);
  background: var(--grey-50) !important;
  padding: 6px 8px;
  height: 44px;
}
.RU-Chip-Text {
  font-size: var(--font-size-xs);
  font-weight: 500;
  color: var(--grey-900);
}

</style>
